"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PurchaseTicketRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class PurchaseTicketRequestDto {}
exports.PurchaseTicketRequestDto = PurchaseTicketRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Square payment source: the card / Apple Pay / Google Pay nonce from the In-App Payments SDK ' + '(sandbox test nonces like `cnon:card-nonce-ok` also work).'
}), __metadata("design:type", String)], PurchaseTicketRequestDto.prototype, "sourceId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Client-generated key (≤ 40 chars), one per nonce. Re-sending the same key (e.g. after a network drop) ' + 'never charges twice — it returns the original ticket.'
}), __metadata("design:type", String)], PurchaseTicketRequestDto.prototype, "idempotencyKey", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  default: 1,
  minimum: 1,
  maximum: 10
}), __metadata("design:type", Number)], PurchaseTicketRequestDto.prototype, "quantity", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Total in cents the buyer was shown (unit price × quantity). The server charges its own current price ' + 'and refuses with TicketPriceChanged when it differs, so nobody pays an amount they did not see.'
}), __metadata("design:type", Number)], PurchaseTicketRequestDto.prototype, "expectedTotalCents", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Buyer verification (SCA / 3DS) token, when the SDK produced one.'
}), __metadata("design:type", String)], PurchaseTicketRequestDto.prototype, "verificationToken", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.EventSource,
  required: false,
  description: 'Where the event screen was opened from. Omitted by older app builds.'
}), __metadata("design:type", String)], PurchaseTicketRequestDto.prototype, "source", void 0);
//# sourceMappingURL=PurchaseTicketRequest.dto.js.map